import { useEffect, useState } from 'react';

import * as SC from '@/components/login/LoginErrorBox.style';
import strings from '@/i18n';
import useLogin from '@/stores/loginStore';
import { fancyTimeFormat } from '@/utils/fancyTimeFormat';
import { getLoginAlertStrings } from '@/utils/getLoginAlertStrings';

const LoginErrorBox = () => {
  const { loginStatus, resetLoginStatus } = useLogin();

  const [lockTime, setLockTime] = useState(-1);

  useEffect(() => {
    if (loginStatus.retryCountDown) {
      setLockTime(loginStatus.retryCountDown);
    }

    if (!loginStatus.retryCountDown && lockTime !== -1) {
      setLockTime(-1);
    }
  }, [loginStatus.retryCountDown]);

  useEffect(() => {
    if (lockTime === -1) {
      return;
    }

    if (!lockTime) {
      resetLoginStatus();
    }
    if (lockTime) {
      const timer = setTimeout(() => {
        setLockTime((prev) => prev - 1);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [lockTime]);

  return (
    <SC.Box>
      <SC.ErrorText>{getLoginAlertStrings(loginStatus.type, loginStatus.failCount)}</SC.ErrorText>
      {lockTime > 0 && (
        <SC.GuideText>{strings.LOGIN__RETRY_ALERT.replace('{0}', fancyTimeFormat(lockTime))}</SC.GuideText>
      )}
    </SC.Box>
  );
};

export default LoginErrorBox;
